import {
  PinInputProps as MantinePinInputProps,
  PinInput as MantinePinInput,
} from '@mantine/core';

export type PinInputProps = MantinePinInputProps;

export const PinInput = MantinePinInput;

PinInput.displayName = 'PinInput';
